import { Injectable } from "@angular/core";
import { format, isPast, isSameDay } from "date-fns";
import { Constants } from "../../../models/constants";
import { StatsRequest } from "../../../models/stats-request";
import { ReminderResponse, SelectedDateRange } from "../Models/dashboard.model";
import {BehaviorSubject, Observable} from "rxjs";
import {UserDetails} from "../../../models/userDetails";
import {Meeting} from "../../../modules/meetings-workflow/models/meeting.model";

@Injectable({
    providedIn: "root",
})
export class DashboardUtilService {
    private usersToAssignMeetingBehaviourSubj: BehaviorSubject<UserDetails[]> = new BehaviorSubject<UserDetails[]>([]);
    usersToAssignMeetingObservable$: Observable<UserDetails[]> = this.usersToAssignMeetingBehaviourSubj.asObservable();

    private selectedMeetingBehaviourSubj: BehaviorSubject<Meeting | null> = new BehaviorSubject<Meeting | null>(null);
    selectedMeetingObservable$: Observable<Meeting | null> = this.selectedMeetingBehaviourSubj.asObservable();

    constructor() {}

    setSelectedDateRangeToStatsRequest(
        selectedDateRange: SelectedDateRange | null | undefined,
        statsRequest: StatsRequest,
    ) {
        // Helper function to format date
        const formatDate = (date: string | null | undefined, timeConst: string): string | null => {
            if (date && date !== "") {
                const formattedDate = format(new Date(date), "yyyy-MM-dd");
                return `${formattedDate}T${timeConst}`;
            }
            return null;
        };

        // Setting fromDate and toDate using the helper function
        statsRequest.fromDate = formatDate(
            selectedDateRange?.selectedFromDate,
            Constants.StatsRequestConstants.FROM_DATE_TIME,
        );
        statsRequest.toDate = formatDate(
            selectedDateRange?.selectedToDate,
            Constants.StatsRequestConstants.TO_DATE_TIME,
        );
    }

    getFutureRemindersData(reminders: ReminderResponse[]): ReminderResponse[] {
        const futureReminders = reminders.filter((reminder) => {
            return (
                reminder.reminderDate &&
                !isSameDay(new Date(reminder.reminderDate), new Date()) &&
                !isPast(new Date(reminder.reminderDate))
            );
        });

        const nonCompletedReminders = futureReminders.filter((reminder) => reminder.reminderStatus !== "Completed");
        const completedReminders = futureReminders.filter((reminder) => reminder.reminderStatus === "Completed");
        return [...nonCompletedReminders, ...completedReminders];
    }

    getTodayRemindersData(reminders: ReminderResponse[]): ReminderResponse[] {
        let todayReminders = reminders.filter((reminder) => {
            return reminder.reminderDate && isSameDay(new Date(reminder.reminderDate), new Date());
        });

        const nonCompletedReminders = todayReminders.filter((reminder) => reminder.reminderStatus !== "Completed");
        const completedReminders = todayReminders.filter((reminder) => reminder.reminderStatus === "Completed");
        return [...nonCompletedReminders, ...completedReminders];
    }

    getOldRemindersData(allRemindersData: ReminderResponse[]) {
        let oldReminders = allRemindersData.filter((reminder) => {
            return (
                reminder.reminderDate &&
                !isSameDay(new Date(reminder.reminderDate), new Date()) &&
                isPast(new Date(reminder.reminderDate))
            );
        });

        const nonCompletedReminders = oldReminders.filter((reminder) => reminder.reminderStatus !== "Completed");
        const completedReminders = oldReminders.filter((reminder) => reminder.reminderStatus === "Completed");
        return [...nonCompletedReminders, ...completedReminders];
    }


    emitUsersToAssignMeetingEvent(users: UserDetails[]){
        this.usersToAssignMeetingBehaviourSubj.next(users);
    }
    emitSelectedMeetingCardEvent(meeting: Meeting){
        this.selectedMeetingBehaviourSubj.next(meeting);
    }
}
